// 2025-05-04 swiperのエフェクトを使うために追加
import { EffectCube } from 'swiper/modules';

Swiper.use([EffectCube]);

import Swiper from "swiper";
import "@/styles/storeeel-swiper.css";
import { setSwiperInstance } from "@/helpers/swiperInstance";
import { isCampaignLoopPlaybackEnabled } from "@/helpers/campaignSettings";
import { REEL_FAST_SWIPE_SPEED_MS } from "@/modules/actions/mobile/reelMotionConfig";
import { isReelLike } from "@/helpers/isReelLike";

export default function initSwiper(options = {}) {
  let swiper;
  const loopPlaybackEnabled = isCampaignLoopPlaybackEnabled(window.storeeelItems);
  const swiperElement = options.element || document.querySelector(".storeeelSwiper");
  if (!swiperElement) return;

  if (window.storeeelItems.isMobile) {
    if (window.storeeelItems.frame === "circle") {
      // モバイルかつcircleフレームなら cube エフェクトで初期化
      swiper = new Swiper(swiperElement, {
        effect: "cube",
        // ストーリー型のループは loop_playback_enabled=true のときのみ
        loop: loopPlaybackEnabled,
        grabCursor: true,
        slidesPerView: 1,
        // Swiperは「ゆっくりスワイプ(=long swipe)」だと移動距離が大きくないとスライドしないため、
        // 速いスワイプと同じ距離感でグループ移動できるように閾値を調整する。
        threshold: 10,
        longSwipesRatio: 0.2,
        speed: 500,
        cubeEffect: {
          shadow: false,
          slideShadows: false,
          shadowOffset: 0,
          shadowScale: 0.94,
        },
        initialSlide: options.initialSlide || 0,
      });
    } else {
      // モバイルだが frameがcircleでない
      // 05-05 縦方向にスライドするよう調整
      swiper = new Swiper(swiperElement, {
        direction: 'vertical',
        effect: 'slide',
        // リール型・タイル型は loop_playback_enabled=true のときのみ clone を使ってループさせる
        loop: isReelLike(window.storeeelItems.frame) && loopPlaybackEnabled,
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: true,
        threshold: 10,
        resistanceRatio: 2000,
        speed: REEL_FAST_SWIPE_SPEED_MS,
        // 無限に高さが調整される要因？
        // autoHeight: true,
        initialSlide: options.initialSlide || 0,
        touchStartPreventDefault: false,
        passiveListeners: false,
      });
    }
  } else {
    if (window.storeeelItems.frame === "circle") {
      // PCかつcircle → 特別な処理があればここに書く
    }

    // PC 通常
    swiper = new Swiper(swiperElement, {
      centeredSlides: true,
      // PC + square/tile は「巻き戻し」ではなく loop（複製スライド）で自然にループさせる
      loop: isReelLike(window.storeeelItems.frame) && loopPlaybackEnabled,
      allowTouchMove:false,
      slidesPerView: 2.6,
      spaceBetween: 0,
      speed: 400,
      initialSlide: options.initialSlide || 0,
    });
  }

  setSwiperInstance(swiper);
}
